import { render, staticRenderFns } from "./ApprovalConfig.vue?vue&type=template&id=4e52ffd6&"
import script from "./ApprovalConfig.vue?vue&type=script&lang=js&"
export * from "./ApprovalConfig.vue?vue&type=script&lang=js&"
import style0 from "./ApprovalConfig.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports